"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "polinago": {
    "c7438e9f": [{
      "hkey": "cf83f1bb",
      "slug": "polinago",
      "name": "Polinago",
      "primary": true,
      "skipSearch": false
    }],
    "brandola": [{
      "hkey": "cf83f1bb",
      "slug": "polinago",
      "name": "Polinago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd081cde": [{
      "hkey": "cf83f1bb",
      "slug": "polinago",
      "name": "Polinago",
      "primary": true,
      "skipSearch": false
    }],
    "cassano": [{
      "hkey": "cf83f1bb",
      "slug": "polinago",
      "name": "Polinago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f3ee1ba2": [{
      "hkey": "cf83f1bb",
      "slug": "polinago",
      "name": "Polinago",
      "primary": true,
      "skipSearch": false
    }],
    "gombola": [{
      "hkey": "cf83f1bb",
      "slug": "polinago",
      "name": "Polinago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "273b92bc": [{
      "hkey": "cf83f1bb",
      "slug": "polinago",
      "name": "Polinago",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "cf83f1bb",
      "slug": "polinago",
      "name": "Polinago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "897f60da": [{
      "hkey": "cf83f1bb",
      "slug": "polinago",
      "name": "Polinago",
      "primary": true,
      "skipSearch": false
    }],
    "talbignano": [{
      "hkey": "cf83f1bb",
      "slug": "polinago",
      "name": "Polinago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;